import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import BreadCrumb from "Common/BreadCrumb";
import ReviewsRating from "./Reviews&Rating";
import { getAllReviews } from "api/apis";

const ReviewRating = () => {
  document.title = "Reviews & Ratings";

  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const data = await getAllReviews();
        setReviews(data.reviews); // assuming the shape is { reviews: [...] }
        console.log("Data: ", data.reviews);
      } catch (error) {
        console.error("Error fetching reviews", error);
      }
    };

    fetchReviews();
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Reviews & Ratings" pageTitle="More" />
        <Row>
          <ReviewsRating reviews={reviews} setReviews={setReviews} />
        </Row>
      </Container>
    </div>
  );
};

export default ReviewRating;
